import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { SpaceDiscriminator, useGetBuildingsByIdOwnerQuery, usePutSpacesByIdOwnerMutation } from '@client/api';
import { PageDetailContent } from '@client/toolkit';

import { PageContentAnimation } from '../../../../../components';
import { CompaniesCard } from '../../../components/companies-card/companies-card.component';

export function SpaceCompaniesOwnersRoute() {
  const { t: tType } = useTranslation('type');
  const { spaceId } = useParams<{
    spaceId: string;
    discriminator: SpaceDiscriminator;
  }>();
  const { t: tNotification } = useTranslation('notification');

  const {
    data: buildingOwners,
    isFetching,
    refetch,
  } = useGetBuildingsByIdOwnerQuery({ id: spaceId ?? '' }, { skip: !spaceId });

  const [putOwners] = usePutSpacesByIdOwnerMutation();
  return (
    <PageDetailContent align="left">
      <PageContentAnimation>
        <CompaniesCard
          role={'Owner'}
          spaceId={spaceId}
          title={tType(`RelationshipType.Owner`, { context: 'plural' })}
          isLoading={isFetching}
          companies={buildingOwners ?? []}
          onEdit={(data) =>
            putOwners({ id: spaceId ?? '', body: { owners: data.map((company) => company.id) } })
              .unwrap()
              .then(() => {
                refetch();
                toast.success(tNotification('editing.fulfilled'));
              })
          }
        />
      </PageContentAnimation>
    </PageDetailContent>
  );
}
